/*
  Trade account form: the source attribution field, the consumer redirect and
  the honeypot.

  All three behaviours are progressive. With this script blocked or broken the
  form still submits, the organisation type still posts its real value, the
  Source field posts "direct", and the person answering routes the enquiry by
  hand. Nothing here is load bearing for data capture; the Liquid is.
*/

(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

  // Reads the four UTM parameters off the page URL into one string such as
  // "utm_source=meta; utm_medium=paid-social; utm_campaign=cf-partner". With no
  // parameters present the field keeps its Liquid value, the literal "direct",
  // so a missing value can be told from an unset one. canonical_url strips the
  // query string, which is why Liquid cannot do this.
  function sourceFromQuery(search) {
    var parts = [];
    if (!search || typeof URLSearchParams === 'undefined') return '';
    var params = new URLSearchParams(search);
    for (var i = 0; i < UTM_KEYS.length; i++) {
      var value = params.get(UTM_KEYS[i]);
      if (value) {
        parts.push(UTM_KEYS[i] + '=' + value.slice(0, 100));
      }
    }
    return parts.join('; ');
  }

  function setUp(form) {
    if (form.dataset.tradeFormReady === 'true') return;
    form.dataset.tradeFormReady = 'true';

    var source = form.querySelector('[data-trade-source]');
    var orgType = form.querySelector('[data-trade-org-type]');
    var panel = form.querySelector('[data-trade-consumer-panel]');
    var submit = form.querySelector('[data-trade-submit]');
    var honeypot = form.querySelector('[data-trade-honeypot]');

    if (source) {
      var fromQuery = sourceFromQuery(window.location.search);
      if (fromQuery) {
        source.value = fromQuery;
      }
    }

    if (orgType && panel && submit) {
      var consumerValue = orgType.getAttribute('data-consumer-value') || '';

      var syncConsumerPanel = function () {
        var isConsumer = orgType.value === consumerValue;
        panel.hidden = !isConsumer;
        submit.disabled = isConsumer;
        if (isConsumer) {
          submit.setAttribute('aria-disabled', 'true');
        } else {
          submit.removeAttribute('aria-disabled');
        }
      };

      orgType.addEventListener('change', syncConsumerPanel);
      // Browsers restore a selected option on back navigation, so read the
      // current state rather than assuming the placeholder is still selected.
      syncConsumerPanel();
    }

    if (honeypot) {
      form.addEventListener('submit', function (event) {
        if (honeypot.value !== '') {
          event.preventDefault();
        }
      });
    }
  }

  function init() {
    var forms = document.querySelectorAll('.trade-form__form');
    for (var i = 0; i < forms.length; i++) {
      setUp(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The customiser re-renders a section without reloading the page.
  document.addEventListener('shopify:section:load', init);
})();
